import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  listCardContainer: {
    cursor: 'pointer',

    '& .card__description_div': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '4px 8px',
      gap: 8,
      width: 'auto',
      height: 29,
      justifyContent: 'center',
      background: '#FFFCFC',
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 100,
      margin: '0 8px 16px 0 '
    },
    '& .card__description_item': {
      fontSize: '14px!important',
      textAlign: 'center',
      fontWeight: 400,
      color: theme.palette.primary.main,
    },
  },
}))
